// types
import { type ModuleType as Customs } from "./_definitions"
import { type State } from "../../types"

export const customsSelector = (state: State): Customs => state.customs
